module.exports = __webpack_public_path__ + "maxusAstara.c2629c1e360fa0b6eadb.png";